import { mapActions, mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import RosterParentEmails from './RosterParentEmails';
import RosterStudentForm from './RosterStudentForm';
import RosterStaffForm from './RosterStaffForm';
export default {
  name: 'RostersEdit',
  props: {
    projectId: {
      type: String,
      required: true
    },
    projectUpload: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchRoster({
      projectID: this.projectId
    });
  },
  methods: {
    ...mapActions('rosters', ['fetchRoster', 'submitRoster']),
    onUploadSchoolRosters() {
      this.submitRoster({
        projectID: this.projectId,
        form: this.formData
      }).then(responseData => {
        this.$store.commit('rosters/formReset');
        if (responseData && responseData.message) {
          const footer = `
                            Click <a href="/projects/${this.projectId}/rosters" class="mx-1">here</a> to return.
                        `;
          Swal.fire({
            icon: 'warning',
            text: null,
            title: 'Almost Done!',
            footer,
            position: 'center',
            customClass: {
              confirmButton: 'btn btn-lg btn-block sgp-btn-default'
            },
            buttonsStyling: false,
            showCloseButton: false,
            showCancelButton: false,
            confirmButtonText: 'UPLOAD ROSTERS'
          }).then(result => {
            if (result.isConfirmed) {
              if (this.projectUpload) window.open(this.projectUpload);
            }
            window.location.replace(`/projects/${this.projectId}/rosters`);
          });
        }
      });
      this.$store.commit('rosters/errorsReset');
    }
  },
  computed: {
    ...mapGetters('rosters', ['isParentEmailsNone', 'projectDetails', 'projectLoading', 'formErrors', 'formData', 'isStaff']),
    submitText() {
      if (this.projectDetails && this.projectDetails.portal_project) {
        const {
          roster_submitted
        } = this.projectDetails.portal_project;
        if (roster_submitted === 'Yes') {
          return 'Resubmit Information';
        }
      }
      return 'Submit Information';
    }
  },
  components: {
    RosterParentEmails,
    RosterStudentForm,
    RosterStaffForm
  }
};